import moment from 'moment';
export const getTemplateDataUpdates = (dateShiftUpdates, list)=>{
    const dataUpdates = [];
    Object.values(dateShiftUpdates).forEach(({ id, startDate, dueDate })=>{
        const update = {
            id
        };
        const currentEntity = list[id];
        if (startDate) {
            update.startDay = Math.abs(moment().startOf('day').diff(moment(startDate), 'day'));
        }
        if (startDate || dueDate) {
            const _startDate = startDate || (currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.startDate);
            const _dueDate = dueDate || (currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.dueDate);
            update.duration = Math.round(moment(_dueDate).endOf('day').diff(moment(_startDate).startOf('day'), 'days', true));
        }
        dataUpdates.push(update);
    });
    return dataUpdates;
};
